<template>
  <div class="hotel-info-card">
    <div class="hotel-info-card__top">
      <div class="hotel-info-card__title">
        <div class="hotel-info-card__house-icon">
          <img src="@/assets/img/house-icon.svg" alt="">
        </div>
        <span class="hotel-info-card__name">{{ hotel.name }} {{ hotel.rating }}*</span>
      </div>
      <div class="hotel-info-card__stars">
        <star-rating
          :rating="hotel.rating"
          :read-only="true"
          :star-size="20"
          :show-rating="false"
          :inline="true"
          :rounded-corners="true"
          :increment="0.5"
          active-color="#eb9514"
          inactive-color="#d1d1d1"
        />
      </div>
      <div class="hotel-info-card__rating">
        <a v-if="hotel.booking" :href="hotel.booking" target="_blank">
          <img src="@/assets/img/booking-active-icon.svg" alt=""> {{ hotel.booking_rating }}
        </a>
        <img v-else src="@/assets/img/booking-not-active-icon.svg" alt="">
      </div>
      <div class="hotel-info-card__rating">
        <a v-if="hotel.tripadvisor" :href="hotel.tripadvisor" target="_blank">
          <img src="@/assets/img/tripadvisor-active-icon.svg" alt=""> {{ hotel.tripadvisor_rating }}
        </a>
        <img v-else src="@/assets/img/tripadvisor-not-active-icon.svg" alt="">
      </div>
    </div>
    <div class="hotel-info-card__main">
      <div class="hotel-info-card__row">
        <div class="hotel-info-card__times">
          <div class="hotel-info-card__between">
            <div class="hotel-info-card__key">Check-in:</div>
            <div class="hotel-info-card__val">{{ hotel.check_in }}</div>
          </div>
          <div class="hotel-info-card__between">
            <div class="hotel-info-card__key">Check-out:</div>
            <div class="hotel-info-card__val">{{ hotel.check_out }}</div>
          </div>
        </div>
      </div>
      <div class="hotel-info-card__row">
        <div class="hotel-info-card__sub-title">Age settings:</div>
        <div class="hotel-info-card__ageses">
          <div v-for="age in hotel.age_settings" :key="age.age_type.code" class="hotel-info-card__age-row">
            <div class="hotel-info-card__age-icon">
              <img :src="require(`@/assets/img/${age.age_type.code}-icon.svg`)" alt="Pic">
            </div>
            <div class="hotel-info-card__age">
              <div class="hotel-info-card__age-text">{{ age.age_type.name }}:</div>
              <div class="hotel-info-card__age-text">
                {{ age.age_type.code === 'child' ? age.to_value : age.age_type.code === 'adult' ? age.from_value : `${age.from_value}-${age.to_value}` }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hotel-info-card__row">
        <div class="hotel-info-card__sub-title">Amenities:</div>
        <div class="hotel-info-card__amenities">
          <div v-for="amenity in hotel.amenities" :key="amenity.code" class="hotel-info-card__amenity">
            <div v-if="amenity.icon" class="hotel-info-card__amenity-icon" v-html="amenity.icon"></div>
            <div class="hotel-info-card__amenity-name">{{ amenity.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'AppHotelInfoCard',
  components: { StarRating },
  props: {
    hotel: {
      type: Object
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="sass">
.hotel-info-card
  margin-bottom: 10px
  border: 1px solid #dfdfdf
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)

.hotel-info-card__top
  display: flex
  align-items: center
  padding: 12px 20px 10px
  border-bottom: 1px solid #dfdfdf

.hotel-info-card__main
  padding: 18px 20px 20px

.hotel-info-card__title
  display: flex
  align-items: center
  gap: 12px
  margin-right: 10px

.hotel-info-card__house-icon
  line-height: 0

.hotel-info-card__name
  font-weight: 500

.hotel-info-card__stars
  margin-right: 30px
  transform: translateY(4px)

.hotel-info-card__rating
  margin-right: 14px
  line-height: 0

  a
    display: flex
    align-items: center
    gap: 4px
    color: #0a0a0a
    font-size: 14px
    font-weight: 500

.hotel-info-card__row
  margin-bottom: 20px

  &:last-child
    margin-bottom: 0

.hotel-info-card__times
  display: flex
  align-items: center
  gap: 30px

.hotel-info-card__between
  display: flex
  align-items: center
  gap: 10px

.hotel-info-card__key
  color: #5f5f5f

.hotel-info-card__val
  font-weight: 500

.hotel-info-card__sub-title
  margin-bottom: 6px
  color: #5f5f5f

.hotel-info-card__ageses
  display: flex
  align-items: flex-end
  gap: 30px

.hotel-info-card__age-row
  display: flex
  align-items: flex-end
  gap: 8px

.hotel-info-card__age-icon
  line-height: 0

.hotel-info-card__age-text
  font-size: 13px
  font-weight: 500

.hotel-info-card__age
  display: flex
  align-items: center
  gap: 6px

.hotel-info-card__amenities
  display: flex
  align-items: center
  gap: 10px

.hotel-info-card__amenity
  display: flex
  align-items: center
  gap: 6px
  padding: 8px 10px 7px
  border-radius: 6px
  background-color: #f7f5f5
  color: #585858
  font-size: 13px

.hotel-info-card__amenity-icon
  line-height: 0
</style>